/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ERPSyncCustomer = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ERPSyncCustomer model module.
   * @module model/ERPSyncCustomer
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ERPSyncCustomer</code>.
   * @alias module:model/ERPSyncCustomer
   * @class
   */
  var exports = function() {
    var _this = this;

























  };

  /**
   * Constructs a <code>ERPSyncCustomer</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ERPSyncCustomer} obj Optional instance to populate.
   * @return {module:model/ERPSyncCustomer} The populated <code>ERPSyncCustomer</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('OrganizationIdentifier')) {
        obj['OrganizationIdentifier'] = ApiClient.convertToType(data['OrganizationIdentifier'], 'String');
      }
      if (data.hasOwnProperty('CustomerCode')) {
        obj['CustomerCode'] = ApiClient.convertToType(data['CustomerCode'], 'String');
      }
      if (data.hasOwnProperty('CustomerGroupName')) {
        obj['CustomerGroupName'] = ApiClient.convertToType(data['CustomerGroupName'], 'String');
      }
      if (data.hasOwnProperty('ParentCustomerID')) {
        obj['ParentCustomerID'] = ApiClient.convertToType(data['ParentCustomerID'], 'Integer');
      }
      if (data.hasOwnProperty('NameExtension')) {
        obj['NameExtension'] = ApiClient.convertToType(data['NameExtension'], 'String');
      }
      if (data.hasOwnProperty('AddressLine')) {
        obj['AddressLine'] = ApiClient.convertToType(data['AddressLine'], 'String');
      }
      if (data.hasOwnProperty('AddressLineExtension')) {
        obj['AddressLineExtension'] = ApiClient.convertToType(data['AddressLineExtension'], 'String');
      }
      if (data.hasOwnProperty('PostalCode')) {
        obj['PostalCode'] = ApiClient.convertToType(data['PostalCode'], 'String');
      }
      if (data.hasOwnProperty('City')) {
        obj['City'] = ApiClient.convertToType(data['City'], 'String');
      }
      if (data.hasOwnProperty('FullAddress')) {
        obj['FullAddress'] = ApiClient.convertToType(data['FullAddress'], 'String');
      }
      if (data.hasOwnProperty('CountryCodeISO3166')) {
        obj['CountryCodeISO3166'] = ApiClient.convertToType(data['CountryCodeISO3166'], 'String');
      }
      if (data.hasOwnProperty('LocationLatitude')) {
        obj['LocationLatitude'] = ApiClient.convertToType(data['LocationLatitude'], 'Number');
      }
      if (data.hasOwnProperty('LocationLongitude')) {
        obj['LocationLongitude'] = ApiClient.convertToType(data['LocationLongitude'], 'Number');
      }
      if (data.hasOwnProperty('RegionID')) {
        obj['RegionID'] = ApiClient.convertToType(data['RegionID'], 'Integer');
      }
      if (data.hasOwnProperty('ExternalID')) {
        obj['ExternalID'] = ApiClient.convertToType(data['ExternalID'], 'String');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('Code')) {
        obj['Code'] = ApiClient.convertToType(data['Code'], 'String');
      }
      if (data.hasOwnProperty('ParentGroupName')) {
        obj['ParentGroupName'] = ApiClient.convertToType(data['ParentGroupName'], 'String');
      }
      if (data.hasOwnProperty('ParentGroupID')) {
        obj['ParentGroupID'] = ApiClient.convertToType(data['ParentGroupID'], 'Integer');
      }
      if (data.hasOwnProperty('IsUserOverride')) {
        obj['IsUserOverride'] = ApiClient.convertToType(data['IsUserOverride'], 'Boolean');
      }
      if (data.hasOwnProperty('CompanyLegalEntityID')) {
        obj['CompanyLegalEntityID'] = ApiClient.convertToType(data['CompanyLegalEntityID'], 'Integer');
      }
      if (data.hasOwnProperty('IsActive')) {
        obj['IsActive'] = ApiClient.convertToType(data['IsActive'], 'Boolean');
      }
      if (data.hasOwnProperty('DetailsSynced')) {
        obj['DetailsSynced'] = ApiClient.convertToType(data['DetailsSynced'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} OrganizationIdentifier
   * @default ''
   */
  exports.prototype['OrganizationIdentifier'] = '';
  /**
   * @member {String} CustomerCode
   * @default ''
   */
  exports.prototype['CustomerCode'] = '';
  /**
   * @member {String} CustomerGroupName
   * @default ''
   */
  exports.prototype['CustomerGroupName'] = '';
  /**
   * @member {Integer} ParentCustomerID
   */
  exports.prototype['ParentCustomerID'] = undefined;
  /**
   * @member {String} NameExtension
   * @default ''
   */
  exports.prototype['NameExtension'] = '';
  /**
   * @member {String} AddressLine
   * @default ''
   */
  exports.prototype['AddressLine'] = '';
  /**
   * @member {String} AddressLineExtension
   * @default ''
   */
  exports.prototype['AddressLineExtension'] = '';
  /**
   * @member {String} PostalCode
   * @default ''
   */
  exports.prototype['PostalCode'] = '';
  /**
   * @member {String} City
   * @default ''
   */
  exports.prototype['City'] = '';
  /**
   * @member {String} FullAddress
   * @default ''
   */
  exports.prototype['FullAddress'] = '';
  /**
   * @member {String} CountryCodeISO3166
   * @default ''
   */
  exports.prototype['CountryCodeISO3166'] = '';
  /**
   * @member {Number} LocationLatitude
   */
  exports.prototype['LocationLatitude'] = undefined;
  /**
   * @member {Number} LocationLongitude
   */
  exports.prototype['LocationLongitude'] = undefined;
  /**
   * @member {Integer} RegionID
   */
  exports.prototype['RegionID'] = undefined;
  /**
   * @member {String} ExternalID
   * @default ''
   */
  exports.prototype['ExternalID'] = '';
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} Code
   * @default ''
   */
  exports.prototype['Code'] = '';
  /**
   * @member {String} ParentGroupName
   * @default ''
   */
  exports.prototype['ParentGroupName'] = '';
  /**
   * @member {Integer} ParentGroupID
   */
  exports.prototype['ParentGroupID'] = undefined;
  /**
   * @member {Boolean} IsUserOverride
   * @default false
   */
  exports.prototype['IsUserOverride'] = false;
  /**
   * @member {Integer} CompanyLegalEntityID
   */
  exports.prototype['CompanyLegalEntityID'] = undefined;
  /**
   * @member {Boolean} IsActive
   * @default false
   */
  exports.prototype['IsActive'] = false;
  /**
   * @member {Boolean} DetailsSynced
   * @default false
   */
  exports.prototype['DetailsSynced'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


